import { render, staticRenderFns } from "./AnalisiRischiList.vue?vue&type=template&id=793ac7a4&scoped=true"
import script from "./AnalisiRischiList.vue?vue&type=script&lang=js"
export * from "./AnalisiRischiList.vue?vue&type=script&lang=js"
import style0 from "./AnalisiRischiList.vue?vue&type=style&index=0&id=793ac7a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793ac7a4",
  null
  
)

export default component.exports